import { io, Socket } from "socket.io-client";
import { RealtimeSocket, SocketEventHandler } from "./types";

export class SocketIoSocket implements RealtimeSocket {
  private readonly socket: Socket;

  constructor(url: string, userId: string) {
    this.socket = io( url, {
      withCredentials: true,
      auth: { userId },
      query: {
        userId,
      },
    });
  }

  get disconnected() {
    return this.socket.disconnected;
  }

  get connected() {
    return this.socket.connected;
  }

  on(event: string, handler: SocketEventHandler): RealtimeSocket {
    this.socket.on( event, handler );
    return this;
  }

  off(event: string, handler?: SocketEventHandler): RealtimeSocket {
    if ( handler ) this.socket.off( event, handler );
    else this.socket.off( event );

    return this;
  }

  emit(event: string, payload?: any): RealtimeSocket {
    this.socket.emit( event, payload );
    return this;
  }

  disconnect() {
    this.socket.disconnect();
  }
}
